<template>
  <div id="app" :class="appClass">
    <keep-alive>
      <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
import QWebChannel from '@/utils/qwebchannel'
import { mapActions, mapMutations } from 'vuex'
import './utils/SMCaptcha'
export default {
  name: 'App',
  data () {
    return {
      appClass: ''
    }
  },
  created () {
    const redirectSocialError = () => {
      const searchParams = new URLSearchParams(window.location.search)
      // 社媒用户主动取消授权时直接跳转失败页
      if (window.location.pathname === '/' && searchParams.get('error') === 'access_denied') window.location.replace(`/redirect${window.location.search}`)
    }
    window.addEventListener('pageshow', redirectSocialError)
    redirectSocialError()
    if (this.$utils.isQt) {
      this.appClass = ''
    } else if (this.$utils.isPC) {
      this.appClass = 'web'
    } else if (!this.$utils.isPC) {
      this.appClass = 'm'
    }
    const oldUrlParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
    const urlParams = this.$utils.getParamsFromUrl(true)
    this.setBindInfo(urlParams.bindinfo)
    this.setHelpUrl({ gid: urlParams.gid, source_id: urlParams.source_id })
    this.setLoginTypes(urlParams.gid)
    this.setGameSource(urlParams.gid)
    window.localStorage.setItem('sdkParams', JSON.stringify(urlParams))
    // 设置语言
    this.$i18n.locale = urlParams.lang ? urlParams.lang.toLowerCase() : 'en'

    // 社媒授权登录后的结果
    const query = this.$utils.checkCallback()
    if (query && this.$route.name === 'Account') {
      const stateData = this.$utils.parseSocialOauthState(query.state)
      console.log('stateData====', stateData)
      // discord 回调
      if (stateData.platform === 'discord') {
        window.localStorage.setItem('sdkParams', JSON.stringify({ ...oldUrlParams, ...stateData, game_id: stateData.gid }))
        const name = stateData.passportSDK === 'FPX' ? 'OauthFPXLoginCB' : 'OauthLoginCB'
        this.$router.replace({
          name: name,
          query: {
            ...query,
            ...stateData
          }
        })
        return
      }

      // 直接跳转到 callback 页面
      this.$router.replace({
        name: 'OauthCallBack',
        query
      })
      return
    }

    this.initQt()

    this.FETCH_CONF()
    this.initFacebook(urlParams.webLang || 'en_US')
    this.loadFBSDK(urlParams.gid)
  },
  methods: {
    ...mapMutations({
      setGameSource: 'setGameSource',
      setLoginTypes: 'setLoginTypes',
      setBindInfo: 'setBindInfo',
      setHelpUrl: 'setHelpUrl',
      setFbFlag: 'setFbFlag'
    }),
    ...mapActions({
      FETCH_CONF: 'FETCH_CONF'
    }),
    initFacebook (lang) {
      // 加载 facebook js
      (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = `https://connect.facebook.net/${lang}/sdk.js`;
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
    },
    loadFBSDK(gid) {
      const _this = this
      window.fbAsyncInit = function() {
        window.FB.init({
          appId      : process.env.VUE_APP_FACEBOOK_ID || _this.$ENUM.FACEBOOK_ACCOUNT_MAP[gid],
          cookie     : true,                     // Enable cookies to allow the server to access the session.
          xfbml      : true,                     // Parse social plugins on this webpage.
          version    : 'v13.0'           // Use this Graph API version for this call.
        })
        _this.setFbFlag(true)
      }
    },
    initQt () {
      // QT初始化
      if (typeof window.qt !== 'undefined') {
        /* eslint-disable no-new */
        new QWebChannel(window.qt.webChannelTransport, function (channel) {
          const funQtWeb = channel.objects.funQtWeb
          window.funQtWeb = funQtWeb
        })
      } else {
        console.log('qt object obtain fail!')
      }
    }
  }
}
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
  background: #F1F1F1;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  &>div {
    width: 420px;
    height: 315px;
  }
  &.web {
    width: 420px;
    height: 400px;
    box-shadow: 0 0 15px 2px #e4e4e4;
  }
  &.m {
    border-radius: 0;
    &>div {
      width: 100vw;
      height: 100vh;
      &.login {
        .top {
          padding-top: 14vh;
        }
        .content {
          width: 100%;
        }
        .btns {
          margin-top: 100px;
        }
        .account-wrap {
          width: 100%;
          font-size: 0;
        }
      }
      &.verify-wrap {
        justify-content: flex-start;
        padding-top: 120px;
        .code-wrap {
          flex: 0;
          margin: 65px 0;
        }
      }
      &.result-wrap {
        justify-content: flex-start;
        padding-top: 175px;
        &.result-wrap-o {
          padding-bottom: 175px;
        }
        .content {
          flex-grow: 0;
        }
        .btns {
          margin-top: 50px;
        }
      }
    }
  }
}
</style>
